<template>
  <div class="container-ctime">
    <van-popup v-model="showPop" position="bottom" :style="{ height: '35%' }" @close="closePop">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title=""
        :cancel-button-text="$t('lang.cfm.cancelBtn')"
        :confirm-button-text="$t('lang.confirm')"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="confirm(currentDate)"
        @cancel="cancel(currentDate)"
      />
    </van-popup>
  </div>
</template>

<script>
// 这个是 （ 年 月 日 ） 格式
export default {
  props: {
    showPop: {
      default: false
    },
    minDate: {
      type: Object,
      default() {
        return new Date(2023, 0, 1)
      }
    },
    maxDate: {
      type: Object,
      default() {
        return new Date()
      }
    }
  },
  data() {
    return {
      currentDate: new Date(),
      chooseTime: ''
    }
  },
  methods: {
    confirm(time) {
      this.chooseTime = time
      this.$parent.closePop()
      this.$emit('handleCurrentDate', this.chooseTime)
    },
    cancel() {
      this.$parent.closePop()
    },
    closePop() {
      this.$parent.closePop()
    }
  }
}
</script>
